export function reportInitialize() {
    return {
        type: 'API_GET_REPORT_INITIALIZE',
    }
}

export function closeGetReportRegulationFetch() {
    return {
        type: 'API_GET_REPORT_REGULATION_CLOSE_FETCH',
    }
}

export function closeGetReportTaskFetch() {
    return {
        type: 'API_GET_REPORT_TASK_CLOSE_FETCH',
    }
}

export function getReportRegulation(companyId, date) {
    return {
        type: 'API_GET_REPORT_REGULATION',
        payload: {
            request: {
                method: 'GET',
                url: `/companies/${companyId}/reports/regulation`,
                params: {
                    date: date
                }
            }
        }
    }
}

export function getReportTask(companyId, date) {
    return {
        type: 'API_GET_REPORT_TASK',
        payload: {
            request: {
                method: 'GET',
                url: `/companies/${companyId}/reports/task`,
                params: {
                    date: date
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/reports.js